import { getTenantConfig } from '../context/TenantContext'

/**
 * Format a phone number for display on Yousign documents.
 * National-format numbers get the ORG's phone prefix (multi-tenant:
 * +34 for the Spanish org, +49 for the German org, ...).
 */
export function formatPhoneForYousign(phone: string): string {
  const defaultPrefix = getTenantConfig()?.phonePrefix || '+49'
  let cleaned = phone.replace(/[^\d+]/g, '')
  if (cleaned.startsWith('00')) {
    cleaned = '+' + cleaned.substring(2)
  } else if (cleaned.startsWith('0')) {
    cleaned = defaultPrefix + cleaned.substring(1)
  }
  if (!cleaned.startsWith('+')) {
    cleaned = defaultPrefix + cleaned
  }
  return cleaned
}
